module.exports = __webpack_public_path__ + "imgs/hours.acba3be27117ceef23db73897bf62ba5.svg";